import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { useStoreState } from "pullstate";

import { apiPath } from "shared/helpers/apiPath";
import client from "@/helpers/apiClient";
import AddIcon from "@/icons/feedAdd.svg";
import AddIcon20 from "@/icons/addToFeed20.svg";
import RemoveIcon from "@/icons/feedRemove.svg";
import RemoveIcon20 from "@/icons/removeFromFeed20.svg";
import IconButton from "@/components/IconButton";
import { FollowPodcastButtonInteface } from "@/components/FollowPodcastButton/FollowPodcastButton.inteface";
import { UIStore } from "@/store/UIStore";
import { useDataLayer } from "@/helpers/useDataLayer";

import styles from "./FollowPodcastButton.module.scss";

export const FollowPodcastButton: React.FC<FollowPodcastButtonInteface> = ({
  followed,
  slug,
  className,
  variant,
  size,
}) => {
  const { pushToDataLayer } = useDataLayer();
  const { userLoggedIn } = useStoreState(UIStore, (store) => store);
  const [isFollowed, setFollowed] = useState<boolean>(followed);

  useEffect(() => {
    setFollowed(followed);
  }, [followed]);

  const handleFollow = async () => {
    if (!userLoggedIn) {
      return null;
    }

    try {
      isFollowed
        ? await client.delete(apiPath.REMOVE_FOLLOW_PODCAST(slug))
        : await client
            .post(apiPath.FOLLOW_PODCAST, {
              slug,
            })
            .then(() => {
              if (!isFollowed) {
                window?.fbq("trackCustom", "Follow podcast", {
                  podcastTile: slug,
                });
              }
            });
      setFollowed((prevState) => {
        const eventName = !prevState ? "follow_podcast" : "unfollow_podcast";
        pushToDataLayer(eventName, { podcast: slug });
        return !prevState;
      });
    } catch (e) {
      //TODO: add error handling
    }
  };

  const getFollowIcon = () => {
    if (variant === "round") {
      return <AddIcon20 />;
    }
    return <AddIcon />;
  };

  const getUnfollowIcon = () => {
    if (variant === "round") {
      return <RemoveIcon20 />;
    }
    return <RemoveIcon />;
  };

  return (
    <div className={styles.wrapper}>
      <IconButton
        variant={variant}
        size={size}
        active={isFollowed}
        onClick={handleFollow}
        className={classNames(
          styles[variant],
          isFollowed && styles.active,
          "followPodcast",
          className
        )}
      >
        {isFollowed ? getUnfollowIcon() : getFollowIcon()}
        {variant === "withLabel" && (
          <span className={styles.label}>Obserwuj</span>
        )}
      </IconButton>
    </div>
  );
};

export default FollowPodcastButton;
